import { Row, Col, Form } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Input, Button, MaskedInput, Group } from "@dreambigger/design-system/src/components";
import { Header, CodeVerification } from "../../components";
import styles from "../start.module.scss";
import { StartTemplateProps } from "./types";

export default function SquaresTemplate({
  assets,
  brand,
  flow,
  hideHeader,
  loginForm,
  keyByLoginMode,
  formattedCred,
  emailInputRef,
  phoneInputRef,
  handleNext,
  isAdminMode,
  codeVerificationProps,
}: StartTemplateProps) {
  const default_square_img =
    "https://res.cloudinary.com/cotribute/image/upload/v1656016221/acquire/template_assets/square-blue.png";

  return (
    <div className={`${styles.homePage} w-100 h-100 min-h-100vh`}>
      {!hideHeader && <Header brand={brand} />}
      <Group
        className={`w-100 pv-8 flex-column-reverse lg_flex-row min-h-60vh lg_mv-4 tc pa-4 md_ph-6vw lg_pv-8 br-2`}
        style={{
          background: assets.heroBackground
            ? `url(${assets.heroBackground})`
            : `linear-gradient(180deg, rgba(${
                assets.heroBackgroundColor1 || "235, 236, 237"
              }) 0%, rgba(${
                assets.heroBackgroundColor2 || "235, 236, 237"
              }) 100%)`,
        }}
      >
        {/* LEFT COLUMN - HIDE ON MOBILE */}
        <div className="dn lg_flex lg_w-50 pr-5">
          <img
            className="w-100 xl_w-90"
            style={{ maxWidth: "900px", objectFit: "scale-down" }}
            src={assets.heroImage || default_square_img}
          />
        </div>
        {/* RIGHT COLUMN */}
        <div className="w-100 lg_w-50">
          <div className="flex flex-column w-100">
            <span
              className={`textSecondary fwt mb-5 lh-1 f-8 xl_f-9 xxl_f-10 lg_mt-0`}
              dangerouslySetInnerHTML={{
                __html: assets.title ?? "",
              }}
            ></span>
            <span
              className={`textSecondary fwb f-6 md_f-7 xl_f-8 xxl_f-9 mb-6 lh-1`}
              dangerouslySetInnerHTML={{
                __html: assets.subTitle ?? "",
              }}
            />
            <span
              className={`textSecondary f-5 xl_f-6 xxl_f-7 lh-2`}
              dangerouslySetInnerHTML={{
                __html: assets.description ?? "",
              }}
            />
          </div>
          <div
            className="br-4 flex justify-center mt-6 lg_mv-8 pv-4 s-6"
            style={{
              backgroundColor: assets.accentColor1 || brand.primaryColor,
            }}
          >
            <Form
              form={loginForm}
              initialValues={{ [keyByLoginMode]: formattedCred }}
              onFinish={handleNext}
            >
              <label
                className="textSecondary fwb f-6"
                dangerouslySetInnerHTML={{
                  __html: assets.loginTitle || "",
                }}
                style={{ color: "white" }}
              />
              <Row
                align="bottom"
                className="fwb justify-center lg_justify-start"
              >
                <Form.Item
                  name={keyByLoginMode}
                  style={{ paddingLeft: "8px", paddingRight: "8px" }}
                >
                  {flow.financialInstitution.loginMode === "email" ? (
                    <Input
                      className={`br-5 pa-3 mt-3 md_mt-0 ${
                        isAdminMode && "disabled notAllowed"
                      }`}
                      style={{ borderColor: "black", width: "300px" }}
                      placeholder={assets.loginPlaceholder}
                      type="email"
                      ref={emailInputRef}
                      readOnly={isAdminMode}
                      required
                    />
                  ) : (
                    <MaskedInput
                      className={`br-5 pa-3 mt-3 md_mt-0 ${
                        isAdminMode && "disabled notAllowed"
                      }`}
                      placeholder={assets.loginPlaceholder}
                      mask="(000) 000-0000"
                      name="phone"
                      ref={phoneInputRef}
                      readOnly={isAdminMode}
                    />
                  )}
                </Form.Item>

                <div
                  className="min-w-20"
                  style={{ paddingLeft: "8px", paddingRight: "8px" }}
                >
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="lift h-8 ph-6"
                      style={{
                        borderColor: `${assets.accentColor2 || "white"}`,
                        backgroundColor: assets.accentColor2 || "black",
                        color: assets.accentColor2
                          ? brand.primaryTextColor
                          : "white",
                      }}
                    >
                      {assets.submitButtonText} <ArrowRightOutlined />
                    </Button>
                  </Form.Item>
                </div>
              </Row>
            </Form>
          </div>
          {/* Image - Mobile Only */}
          <div className="flex lg_dn justify-center">
            <img
              className="w-100"
              style={{ maxWidth: "700px" }}
              src={
                "https://res.cloudinary.com/cotribute/image/upload/v1656016221/acquire/template_assets/square-blue.png"
              }
            />
          </div>
          {/* - Terms */}
          <Col className="w-100">
            <div
              className="fwt f-4 xl_f-5 xxl_f-6 textSecondary"
              dangerouslySetInnerHTML={{
                __html: assets.landingTermsTitle ?? "",
              }}
            />
            <div
              className={`${styles.terms} f-3 xl_f-4 xxl_f-5 textSecondary`}
              dangerouslySetInnerHTML={{
                __html: assets.landingTermsText ?? "",
              }}
            />
          </Col>
        </div>
      </Group>
      <CodeVerification {...codeVerificationProps} />
    </div>
  );
}
